import { connect } from 'react-redux';
import Wishlist from '../../pages/Wishlist';
import { toggleModal } from '../slices/shareWishlistModalSlice';

const mapState = () => ({});

const mapDispatch = (dispatch) => ({
  toggleModal: () => {
    const action = toggleModal();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(Wishlist);
